// This file has a disco-ui equivalent, but has elements needed in commons so here we are.
// If a better solution is found, feel free to refactor.

export const EUROPEAN_UNION_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

const EUROPE_NON_EU_COUNTRY_CODES = [
  'AD',
  'AL',
  'AX',
  'BA',
  'BV',
  'BY',
  'CH',
  'FO',
  'GB',
  'GG',
  'GI',
  'IM',
  'IS',
  'JE',
  'LI',
  'MC',
  'MD',
  'ME',
  'MF',
  'MK',
  'NO',
  'PN',
  'RS',
  'RU',
  'SJ',
  'SM',
  'UA',
  'VA',
];

export const VAT_COUNTRY_CODES = [
  ...EUROPEAN_UNION_COUNTRY_CODES,
  ...EUROPE_NON_EU_COUNTRY_CODES,
];

export const GST_COUNTRY_CODES = [
  'AU',
  'NZ',
];

export const EUR_EU = 'EUR_EU';

export function isEU(countryCode: string) {
  return EUROPEAN_UNION_COUNTRY_CODES.includes(countryCode);
}

export function isEUOrUK(countryCode: string) {
  return isEU(countryCode) || countryCode === 'GB';
}
